import { forwardRef } from "react";
import React, { useId } from "react";
function SvgAiSearchWithSparkle({ title, titleId, ...props }, ref) {
  const id = useId();
  const toAppend = "_" + id;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      fill="none"
      viewBox="0 0 25 25"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill={`url(#ai-search-with-sparkle_svg__a${toAppend})`}
        d="M10 0c5.523 0 10 4.477 10 10a9.957 9.957 0 0 1-2.258 6.328l6.965 6.965.068.076a1 1 0 0 1-1.406 1.406l-.076-.068-6.965-6.965A9.957 9.957 0 0 1 10 20C4.477 20 0 15.523 0 10c0-.762.086-1.506.248-2.222a1 1 0 1 1 1.95.444 8 8 0 1 0 6.023-6.023A1 1 0 0 1 7.779.247C8.494.086 9.238 0 10 0Z"
      />
      <path
        fill={`url(#ai-search-with-sparkle_svg__b${toAppend})`}
        d="M9.429 6.857c.052 0 .098.035.112.086.442 1.598.774 1.932 2.373 2.373a.117.117 0 0 1 0 .225c-1.598.442-1.931.774-2.373 2.373a.117.117 0 0 1-.225 0c-.442-1.598-.774-1.931-2.373-2.373a.117.117 0 0 1 0-.225c1.598-.442 1.931-.774 2.373-2.373a.117.117 0 0 1 .113-.086Z"
      />
      <path
        fill={`url(#ai-search-with-sparkle_svg__c${toAppend})`}
        d="M4.714 0c.097 0 .181.064.207.157.81 2.93 1.42 3.541 4.35 4.35a.215.215 0 0 1 0 .414c-2.93.81-3.54 1.42-4.35 4.35a.214.214 0 0 1-.413 0c-.81-2.93-1.42-3.54-4.351-4.35a.215.215 0 0 1 0-.413c2.93-.81 3.541-1.42 4.35-4.35A.214.214 0 0 1 4.715 0Z"
      />
      <defs>
        <linearGradient
          id={`ai-search-with-sparkle_svg__a${toAppend}`}
          x1={25}
          x2={-2.066}
          y1={16.927}
          y2={12.428}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#691C9C" />
          <stop offset={0.65} stopColor="#1F3CD7" />
          <stop offset={1} stopColor="#1088EB" />
        </linearGradient>
        <linearGradient
          id={`ai-search-with-sparkle_svg__b${toAppend}`}
          x1={25}
          x2={-2.066}
          y1={16.927}
          y2={12.428}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#691C9C" />
          <stop offset={0.65} stopColor="#1F3CD7" />
          <stop offset={1} stopColor="#1088EB" />
        </linearGradient>
        <linearGradient
          id={`ai-search-with-sparkle_svg__c${toAppend}`}
          x1={25}
          x2={-2.066}
          y1={16.927}
          y2={12.428}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#691C9C" />
          <stop offset={0.65} stopColor="#1F3CD7" />
          <stop offset={1} stopColor="#1088EB" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgAiSearchWithSparkle);
export default ForwardRef;
